/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Stop_Labels_Style_Without_BackgroundInputs */

const fr_settings_stop_labels_style_without_background = /** @type {(inputs: Settings_Stop_Labels_Style_Without_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans fond`)
};

const en_settings_stop_labels_style_without_background = /** @type {(inputs: Settings_Stop_Labels_Style_Without_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without background`)
};

/**
* | output |
* | --- |
* | "Without background" |
*
* @param {Settings_Stop_Labels_Style_Without_BackgroundInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_stop_labels_style_without_background = /** @type {((inputs?: Settings_Stop_Labels_Style_Without_BackgroundInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Stop_Labels_Style_Without_BackgroundInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_stop_labels_style_without_background(inputs)
	return en_settings_stop_labels_style_without_background(inputs)
});